import styled from "styled-components";

// TODO fixa font-properties nedan! Tema etc.
const
  heading = `
  display: block;
  font-size: 24px;
  font-weight: bold;
  margin: 30px 0 5px;
  text-transform: uppercase;
  white-space: nowrap;

  @media (min-width: 1300px) {
    white-space: normal;
  }

  & * {
    vertical-align: baseline;
  }

  &:not( & + p) {
    margin-bottom: 10px;
  }
`;

const description = `
  margin: 10px 0 25px;
  font-size: 14px;
`;

export const _OptionListContainer = styled.div`
  background: ${(props) => (props.background)};
  padding: 15px;
  margin-left: -15px;
  margin-right: -15px;
  
  @media (min-width: 768px) {
    padding: 30px;
    padding-top: ${(props) => (props.$noPaddingTop && '0px')};;
    margin-left: -30px;
    margin-right: -30px;
  }
`;

export const _RadioList = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  > div {
    padding: 20px 0;
  }

  + div,
  + span {
    border-bottom: 1px solid transparent;
    border-image: linear-gradient(to right, transparent, red, transparent);
    border-image-slice: 1;
  }

  .heading {
    font-weight: bold;
    display: inline-block;
    padding-top: 24px;

    &:empty {display: none}

    img {
      display: block;
      width: 90px;
      margin: 10px 0 0;
      border: 1px solid ${({ theme }) => theme.input};

      @media (min-width: 1200px) {
        margin-bottom: 30px;
      }
    }
  }

  .options {
    @media (min-width: 1200px) {
      width: 55%;
    }

    .cost {
      margin-left: 5px;
      font-weight: bold;

      &::before {
        content: "+ ";
      }
    }

    input[type="radio"] {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;

      + label {
        display: block;
        // Float: none is to override scensum css
        float: none !important;
        cursor: pointer;
        font-size: 14px;
        margin: 0px 0px 8px;

        &::before {
          content: "";
          display: inline-block;
          width: 25px;
          height: 25px;
          margin: 0px 10px 0px 0px;
          border-radius: 50%;
          cursor: pointer;
          vertical-align: -9px;
          border: 1px solid ${({ theme }) => theme.input};
        }
      }

      &:checked {
        + label::before {
          background: radial-gradient(
            ${({ theme }) => theme.input} 45%,
            transparent 50%,
            transparent
          );
        }
      }
    }

    &:hover::before {
      box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 8px 0px;
      cursor: pointer;
    }
  }
`;

export const _VerticalList = styled.div`
  .heading {
    ${heading}
    
    &:empty {display: none}
  }

  input {
    display: none;
  }

  label {
    display: block;
    float: none; // Overrides Scensum css where labels are floated
    border-bottom: 1px solid #e1e1e1;
    cursor: pointer;
    transition: background-color 0.25s;

    &:first-child {
      border-top: 1px solid #e1e1e1;
    }

    &:hover {
      background-color: ${({ theme }) => theme.hover};
    }
  }

  .options {
    display: flex;
    align-items: center;
    position: relative;
  }

  input:checked + div {
    background-color: ${({ theme }) => theme.hover};
  }

  img {
    width: 50px;
    padding: 5px;
    margin-right: 10px;
  }
`;

export const _IconContainer = styled.div`
  color: ${({ theme }) => theme.primary};
  position: absolute;
  font-size: 20px;
  right: 20px;

  // Overrides scensum global glyph styling
  .glyphicon-ok-2 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
`;

export const _ThumbnailsList = styled.div`
  .description {
    ${description}
  }

  .options {
    display: grid;
    grid-gap: 30px;
    grid-template-columns: 1fr 1fr 1fr;

    @media (min-width: 768px) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 20px;
    }

    label {
      cursor: pointer;
      font-size: 12px;
      text-align: center;

      input {
        display: none;
      }

      img {
        display: block;
        border: 1px solid #e1e1e1;
        margin-bottom: 5px;
        padding: 6px;
        width: 90%;

        &:hover {
          background-color: ${({ theme }) => theme.hover};
        }
      }

      input:checked + img {
        background-color: ${({ theme }) => theme.hover};
      }
    }
  }

  @media (min-width: 768px) {
    /* margin-top: 15px; */
  }
`;

export const _CardsList = styled.div`
  .heading {
    ${heading}
  }

  .description {
    ${description}
  }
  
  .options {
    display: flex;
    flex-wrap: wrap;

    + .description {
      margin-bottom: 0;
    }

    @media (min-width: 1024px) {
      flex-wrap: nowrap;
    }
  }

  input {
    display: none;
  }

  label:not(.MuiFormLabel-root) {
    cursor: pointer;
    display: flex;
    flex: 1 1 35%;
    position: relative;
    flex-direction: column;
    justify-content: stretch;
    align-self: stretch;
    align-items: center;
    margin: 5px;
    padding: 15px 10px;
    border: 1px solid #e1e1e1;
    background: white;
    transition: all 0.15s;
    text-align: center;

    &:hover {
      background-color: ${({ theme }) => theme.hover};
    }

    img {
      @media (min-width: 768px) {
        width: 40px;
      }
    }

    svg {
      height: 50px;
      width: 50px;
      padding: 5px;
      border-radius: 50%;
    }

    h5 {
      margin-top: 1rem;
      font-size: 12px;
      font-weight: 600;

      @media (min-width: 768) {
        font-size: 16px;
        flex: 1 1 15%;
      }
    }
  }

  input:checked + label {
    border-color: ${({ theme }) => theme.primary};
    /* box-shadow: 0 0 3px 0 ${({ theme }) => theme.darkgrey}; */

    &:hover {
      background: none;
    }
  }
`;

export const CurrentAsscessoryImage = styled.img`
    display: block;
    width: 90px;
    margin: 10px 0px;
    border: 1px solid rgb(29, 29, 29);
`;
